module.exports = __webpack_public_path__ + "img/Tutorial_MainNavigation.0468d3be.png";